import {
  Stack,
  Button,
  FormControlLabel,
  FormGroup,
  Checkbox,
} from "@mui/material";

import { ReactComponent as IconDiamond } from "../../../../../images/icon-diamond.svg";

import { FieldTextarea } from "../../../../../components/Fields";

import "../../styles.css";

export default function PrimeiraEtapa({
  handleChangePanel,
  onSubmit,
  setData,
  data,
  sinaisSintomasList,
}) {
  function handleSetData(value, field) {
    setData((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  }

  const handleSinaisSintomas = (e) => {
    const { value, checked } = e.target;

    if (data.sinaisSintomas === undefined) {
      data.sinaisSintomas = [];
    }

    if (checked) {
      setData((prevState) => ({
        ...prevState,
        sinaisSintomas: [...prevState.sinaisSintomas, value],
      }));
    } else {
      setData((prevState) => ({
        ...prevState,
        sinaisSintomas: prevState.sinaisSintomas.filter((e) => e !== value),
      }));
    }
  };

  return (
    <Stack>
      <form autoComplete="off" onSubmit={onSubmit}>
        <FieldTextarea
          label="Anamnese"
          value={data.anamnese}
          setValue={(value) => handleSetData(value, "anamnese")}
          placeholder="Descreva as queixas do paciente e suas observações sobre o quadro"
        />
        <Stack component="h2" className="titleSection">
          Sinais e sintomas
        </Stack>

        <Stack direction="row" className="labelText" mt={"24px"}>
          Selecione todos que se aplicam: <IconDiamond fill="#FC8518" />
        </Stack>
        <FormGroup
          className="templateGridFormCheckbox CheckboxColor"
          onChange={handleSinaisSintomas}
        >
          {sinaisSintomasList.map(({ key, value }) => {
            return (
              <FormControlLabel
                control={<Checkbox />}
                label={key}
                value={value}
                key={value}
                checked={data.sinaisSintomas.includes(value)}
              />
            );
          })}
        </FormGroup>

        <Stack
          direction="row"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 3,
          }}
        >
          <Button variant="outlined" className="buttonText cancel">
            Cancelar
          </Button>
          <Button
            variant="contained"
            type="submit"
            name="anamneseNeurologica"
            className="buttonText submit"
          >
            Salvar
          </Button>
        </Stack>
      </form>
    </Stack>
  );
}
